<template>
    <div class="bg_banners_slider">
        <div :class="['banners_slider', { 'active': isPopupActive }]">
            <div class="banners_slider_inner">
                <div class="banners_slider_animation">
                    <div class="banners_slide">
                        <img :src="this.currentImage" alt="" class="img-fluid animation_start">
                    </div>
                    <div :class="['banner_slider_curve', { 'animation_play': isLineCrubAnimated }]">
                        <div class="banner_slide_curve_inner">
                            <img src="@/assets/images/full_line_shape.png" alt="" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="['banner_slide', { 'active': isNewActive }]">
            <div class="banner_slide_inner">
                <img src="@/assets/images/slide_img.png" class="img-fluid">
            </div>
        </div>
    </div>
</template>

<script>
import baseImage from '@/assets/images/lange_crub.jpg';
import image1 from '@/assets/images/random_img/lange_crub_1.jpg';
import image2 from '@/assets/images/random_img/lange_crub_2.jpg';
import image3 from '@/assets/images/random_img/lange_crub_3.jpg';
import image4 from '@/assets/images/random_img/lange_crub_4.jpg';
import image5 from '@/assets/images/random_img/lange_crub_5.jpg';

export default {
    name: 'banner-slider',
    components: {
    },
    data() {
        return {
            currentImage: baseImage,
            isPopupActive: false,
            isNewActive: false,
            isLineCrubAnimated: false,
            imageIndex: 0,
            imageInterval: null,
            slideInterval: null,
            images: [baseImage, image1, baseImage, image2, baseImage, image3, baseImage, image4, baseImage, image5, baseImage],
        };
    },
    mounted() {
        this.startImageRotation();
        this.startSlideAnimation();
    },
    beforeUnmount() {
        this.clearAllIntervals();
    },
    methods: {
        startImageRotation() {
            this.imageInterval = setInterval(() => {
                this.imageIndex = (this.imageIndex + 1) % this.images.length;
                this.currentImage = this.images[this.imageIndex];
            }, 2000);
        },
        startSlideAnimation() {
            this.slideInterval = setInterval(() => {
                this.isNewActive = true;
                this.isPopupActive = false;
                setTimeout(() => {
                    this.isLineCrubAnimated = true;
                }, 1000);

                setTimeout(() => {
                    this.isNewActive = false;
                    this.isPopupActive = true;
                    setTimeout(() => {
                        this.isLineCrubAnimated = false;
                    }, 1000);
                }, 10000);
            }, 20000);
        },
        clearAllIntervals() {
            clearInterval(this.imageInterval);
            clearInterval(this.slideInterval);
        }
    },
};
</script>

<style lang="scss" scoped>
@keyframes circle {
    from {
        -webkit-clip-path: circle(0%);
        clip-path: circle(0%);
    }

    to {
        -webkit-clip-path: circle(657px);
        clip-path: circle(657px);
    }
}

@-webkit-keyframes mask-play {
    from {
        -webkit-mask-position: 0% 0;
        mask-position: 0% 0;
    }

    to {
        -webkit-mask-position: 100% 0;
        mask-position: 100% 0;
    }
}

@keyframes mask-play {
    from {
        -webkit-mask-position: 0% 0;
        mask-position: 0% 0;
    }

    to {
        -webkit-mask-position: 100% 0;
        mask-position: 100% 0;
    }
}

.bg_banners_slider {
    position: relative;
    height: 100dvh;
    width: 100%;

    .banners_slider {
        position: relative;
        text-align: center;
        overflow: hidden;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: #000000;
        -webkit-mask: url("../../../assets/slider/images/nature-sprite-2.png");
        mask: url("../../../assets/slider/images/nature-sprite-2.png");
        -webkit-mask-size: 7100% 100%;
        mask-size: 7100% 100%;
        z-index: 10;

        &.active {
            -webkit-animation: mask-play 1.5s steps(70) forwards;
            animation: mask-play 1.5s steps(70) forwards;
            z-index: 11;
        }

        .banners_slider_inner {
            .banners_slide {
                display: block;
                margin: 0 auto;
                height: 100dvh;
                object-fit: cover;
                padding-top: 20px;

                .img-fluid {
                    height: 87%;
                }
            }

            display: inline-block;
            position: relative;
            margin: 0 auto;
            vertical-align: middle;
        }

        .banner_slider_curve {
            .banner_slide_curve_inner {
                position: absolute;
                top: -2px;
                left: -7%;
                right: 0;
                width: 110%;
                bottom: 0;
            }

            .img-fluid {
                height: 100%;
                opacity: 0;
            }

            &.animation_play {
                .img-fluid {
                    animation: 2.8s alternate circle;
                    opacity: 1;
                }
            }
        }

    }

    .banner_slide {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        -webkit-mask: url("../../../assets/slider/images/nature-sprite-2.png");
        mask: url("../../../assets/slider/images/nature-sprite-2.png");
        -webkit-mask-size: 7100% 100%;
        mask-size: 7100% 100%;
        z-index: 10;

        &.active {
            -webkit-animation: mask-play 1.5s steps(70) forwards;
            animation: mask-play 1.5s steps(70) forwards;
            z-index: 11;
        }

        .banner_slide_inner {
            background-image: url("../../../assets/images/lymphomap-landing-blank.jpg");
            height: 100dvh;
            width: 100%;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: top center;
            text-align: center;

            .img-fluid {
                height: 100%;
            }
        }


    }
}
</style>